import { render, staticRenderFns } from "./FullScreenGamePage.vue?vue&type=template&id=4af1923c&scoped=true"
import script from "./FullScreenGamePage.vue?vue&type=script&lang=js"
export * from "./FullScreenGamePage.vue?vue&type=script&lang=js"
import style0 from "./FullScreenGamePage.vue?vue&type=style&index=0&id=4af1923c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af1923c",
  null
  
)

export default component.exports